import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Employee-index-1992f2b7c7f44b8e4-1'),
    routerUrl: '/Employee',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Employee')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Employee-index-1992f2b7c7f44b8e4-2'),
        routerUrl: '/EmployeeForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./EmployeeForm')),
      },
      //$MORE$
    ],
  },
];
